import { ThemeEvents, CartAddEvent, CartErrorEvent, VariantUpdateEvent } from '@theme/events';

document.addEventListener("DOMContentLoaded", () => {
  const atcButton = document.querySelector('button[name="add_custom_bundle"]');
  if (!atcButton || !window.bundleProducts) return;
  console.log("innnn")
  atcButton.addEventListener("click", async function (e) {
    e.preventDefault();

    // Add visual state immediately
    atcButton.classList.add("atc-added");

    // Read properties from button attribute
    const bundleProp = atcButton.getAttribute("data-bundlepro") || "";
    const bundleTitle = atcButton.getAttribute("data-protitle") || "";
    // Add both properties if available
    const itemProperties = {};

    itemProperties._bundlePro = 1;
    if (bundleProp) {
      itemProperties._bundleCount = bundleProp;
    }

    if (bundleTitle) {
      itemProperties._bundleTitle = bundleTitle;
    }

    // 1️⃣ Get selected radio button (strenght)
    const selectedRadio = document.querySelector('input[name^="strength"]:checked');
    if (!selectedRadio) {
      alert("Please select a strength first.");
      return;
    } 

    // Normalize the selected value: remove spaces & lowercase
    const selectedValue = selectedRadio.value.replace(/\s+/g, '').toLowerCase();

    // 2️⃣ Find all metafield variants that match (case & space insensitive)
    const matchedItems = [];
    window.bundleProducts.forEach(product => {
      product.variants.forEach(variant => {
        if (variant.option1) {
          const variantValue = variant.option1.replace(/\s+/g, '').toLowerCase();
          if (variantValue === selectedValue) {
            matchedItems.push({
              id: variant.id,
              quantity: 1,
              properties: itemProperties
            });
          }
        }
      });
    });

    if (!matchedItems.length) {
      alert("No matching variants found for " + selectedRadio.value);
      return;
    }

    console.log("Matched variants:", matchedItems);

    // 3️⃣ Add all matched variants to cart in ONE call
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({ items: matchedItems })
      })
      .then((response) => response.json())
      .then((response) => {
        console.log("response===>", response)
        // ✅ Dispatch Horizon CartAddEvent after successful add
        if (typeof CartAddEvent !== "undefined") {
            atcButton.classList.remove("atc-added");
            this.dispatchEvent(
                new CartAddEvent({}, this.id, {
                    didError: false,
                    source: 'product-form-component-new',
                    itemCount: matchedItems.length,
                    productId: response.items?.[0]?.product_id || null,
                })
            );
        }
      });

      //const data = await res.json();
      //console.log("Bundle added:", data);
    } catch (error) {
      console.error("Add to cart error:", error);
      alert("Something went wrong adding bundle items!");
    }
  });
});
